/**
 * DEFCAT P6 — render a `LocalizedString` to display text.
 *
 * The catalogue payloads carry i18n maps (`{ en, de, … }`). For the baseline
 * editor we render the `en` value (always present per the contract) and fall
 * back to the first available language, then a placeholder. A full locale-aware
 * picker is a follow-up; the editor edits the `en` field directly.
 */
import type { LocalizedString } from "@aeriosiq/types";

export function locText(
  s: LocalizedString | null | undefined,
  placeholder = "(unnamed)",
): string {
  if (!s) return placeholder;
  const en = s.en.trim();
  if (en.length > 0) return en;
  for (const key of Object.keys(s)) {
    const v = s[key];
    if (typeof v === "string" && v.trim().length > 0) return v.trim();
  }
  return placeholder;
}
